import { useCallback } from 'react';

import { assignWithConditionalReplace } from '../../utils/navigationUtils';
import { useClientProps } from '../providers/ClientPropsProvider';

export function useRedirectToUL() {
  const { config } = useClientProps();
  return useCallback(() => {
    const redirectPath = config?.carryoverPathOnSyncUp
      ? `?redirectPath=${encodeURIComponent(window.location.pathname + window.location.search)}`
      : '';

    assignWithConditionalReplace(`${config?.loginUrl ?? '/login'}${redirectPath}`);
  }, [config?.carryoverPathOnSyncUp, config?.loginUrl]);
}
